import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { Document, toDocumentXml } from '../../dataObjects/Document';

export interface ICreateDocumentRequest extends IBaseRequest {
    DOCUMENT?:  Document;
    data?:      string;
}

export class CreateDocumentRequest extends BaseRequest implements ICreateDocumentRequest {
    public DOCUMENT?: Document;
    public data?: string;

    constructor(server: string, session: string, document?: Document, data?: string) {
        super(server, session);
        this.DOCUMENT = document;
        this.data = data;
    }

    public toXml(): string {
        var parameters: string = super.toXml();
        if(this.DOCUMENT) parameters += toDocumentXml(this.DOCUMENT);
        parameters += this.makeNode(this.data, 'data');
        return super.wrapperXml('CreateDocument', parameters);
    }
}
